export enum FormCargoInformationFormValues {
    commodity = 'commodity',
    specialInstructions = 'specialInstructions',
    containerUsageType = 'containerUsageType',
    cargoReadyDate = 'cargoReadyDate',
    containerCount20 = 'containerCount20',
    containerCount40 = 'containerCount40',
    containerCount40HQ = 'containerCount40HQ',
    containerCount45 = 'containerCount45',
    po = 'po',
    willProvideISFForm = 'willProvideISFForm',
    willProvideDocuments = 'willProvideDocuments',
}

export const formCargoInformationInitialValues = {
    [FormCargoInformationFormValues.commodity]: '',
    [FormCargoInformationFormValues.specialInstructions]: '',
    [FormCargoInformationFormValues.containerUsageType]: 'FCL',
    [FormCargoInformationFormValues.cargoReadyDate]: '',
    [FormCargoInformationFormValues.containerCount20]: 0,
    [FormCargoInformationFormValues.containerCount40]: 0,
    [FormCargoInformationFormValues.containerCount40HQ]: 0,
    [FormCargoInformationFormValues.containerCount45]: 0,
    [FormCargoInformationFormValues.po]: '',
    [FormCargoInformationFormValues.willProvideISFForm]: true,
    [FormCargoInformationFormValues.willProvideDocuments]: true,
}